import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token JWT
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const auth = {
  signup: (data) => api.post('/auth/signup', data),
  login: (data) => api.post('/auth/login', data),
  getProfile: () => api.get('/auth/profile'),
  updateProfile: (data) => api.put('/auth/profile', data),
  requestPasswordReset: (email) => api.post('/auth/request-password-reset', { email }),
  resetPassword: (data) => api.post('/auth/reset-password', data),
};

// Booking
export const booking = {
  getDisponibilites: (params) => api.get('/booking/disponibilites', { params }),
  createReservation: (data) => api.post('/booking/reservations', data),
  getMesReservations: () => api.get('/booking/mes-reservations'),
  cancelReservation: (id) => api.put(`/booking/reservations/${id}/cancel`),
};

// Admin
export const admin = {
  getAllReservations: (params) => api.get('/admin/reservations', { params }),
  validateReservation: (id) => api.put(`/admin/reservations/${id}/validate`),
  rejectReservation: (id, raison) => api.put(`/admin/reservations/${id}/reject`, { raison }),
  createDisponibilite: (data) => api.post('/admin/disponibilites', data),
  deleteDisponibilite: (id) => api.delete(`/admin/disponibilites/${id}`),
};

export default api;